import React from 'react'
import { LiaBarsSolid } from 'react-icons/lia'
import { AiOutlineClose } from 'react-icons/ai'
import { BsSearch } from 'react-icons/bs'
import { PiSignInFill } from 'react-icons/pi'
import { SignedIn, SignedOut, UserButton, useUser } from '@clerk/clerk-react'
const Navbar = ({ open, setOpen }) => {
  let { user } = useUser()
  return (
    <header
      className={`w-full fixed top-0 left-0 right-0 z-40 py-4 bg-[#1E1F25] border-b-2 border-[#15161a] md:py-4 overflow-y-hidden transition-all duration-300 
        h-fit `}
    >
      <div className="px-4 mx-auto max-w-[1560px] md:px-6 lg:px-3">
        <div className="flex items-center justify-between">
          <div className="shrink-0 md:invisible flex gap-x-4">
            <div className="flex md:hidden">
              <div
                type="button"
                className="text-white hover:ring-1 focus:ring-1 ring-white bg-[#15161a]  rounded-md"
              >
                <button
                  onClick={() => setOpen(true)}
                  className={`outline-none border-none px-2.5 h-full ${
                    open ? 'hidden' : 'block'
                  }`}
                >
                  <LiaBarsSolid className="w-7 h-auto text-white" />
                </button>
                <button
                  onClick={() => setOpen(false)}
                  className={`border-none px-2.5 h-full  outline-none ${
                    open ? 'block' : 'hidden'
                  }`}
                >
                  <AiOutlineClose className="w-7 h-auto text-white" />
                </button>
              </div>
            </div>
            <a href={'/'} className="flex  items-center">
              <img src="/images/logo.svg" className="h-12 w-auto" />
              <h3 className="text-white text-2xl font-bold ml-1.5">Taskie</h3>
            </a>
          </div>

          <div className="flex-row md:flex hidden justify-center items-center w-full">
            <div className="bg-[#050505] rounded-lg py-3 px-5 flex items-center w-[290px]">
              <input
                type="text"
                placeholder="Search anything..."
                className="flex-grow text-sm bg-transparent w-max text-[#9BABC5] border-none outline-none"
              />
              <BsSearch className="w-5 h-auto text-[#C2C7D0]" />
            </div>
          </div>
          <div>
            <SignedIn>
              <div className="flex items-center gap-x-2">
                <UserButton afterSignOutUrl="/login" />
                <p className="text-white text-sm font-medium whitespace-nowrap">
                  {user.fullName}
                </p>
              </div>
            </SignedIn>
            <SignedOut>
              <button className="flex items-center gap-x-2.5 py-2 px-0 bg-transparent text-white border-b border-transparent hover:border-white border-opacity-40 font-bold text-sm whitespace-nowrap transition-all duration-300">
                Sign in
                <PiSignInFill className="text-white h-5 w-auto" />
              </button>
            </SignedOut>
          </div>
          {/* clerk auth */}
        </div>
      </div>
    </header>
  )
}

export default Navbar
